import { render, staticRenderFns } from "./ModalPurchaseComplete.vue?vue&type=template&id=4d283b05&scoped=true&"
import script from "./ModalPurchaseComplete.vue?vue&type=script&lang=js&"
export * from "./ModalPurchaseComplete.vue?vue&type=script&lang=js&"
import style0 from "./ModalPurchaseComplete.vue?vue&type=style&index=0&id=4d283b05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d283b05",
  null
  
)

export default component.exports